import React, { useEffect } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import ChannelModalLayout from '../Layouts/ChannelModalLayout';
import { getCollectionById } from '../../api/collections';
import Spinner from '../Spinner';
import ChannelInfo from '../Channel/ChannelInfo';
import { useTranslation } from 'react-i18next';
import { resetCache, setChannelCreated, setChannelDeleted, setChannelUpdated } from '../../redux/actions';

const ChannelInfoModal = ({ isOpen, onClose, channelId }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const { channelCreated, channelDeleted, channelUpdated } = useSelector(state => state);

    useEffect(() => {
        const shouldResetCache = channelCreated || channelDeleted || channelUpdated;
        if (shouldResetCache && channelId) {
            queryClient.invalidateQueries(['channel', channelId]);
            dispatch(resetCache());
            dispatch(setChannelCreated(false));
            dispatch(setChannelDeleted(false));
            dispatch(setChannelUpdated(false));
        }
    }, [dispatch, queryClient, channelCreated, channelDeleted, channelUpdated, channelId]);

    const { data: channelData, isLoading, error } = useQuery(
        ['channel', channelId], // Уникальный ключ для каждого канала
        () => getCollectionById(channelId),
        { staleTime: 1000 * 60 * 5, cacheTime: 1000 * 60 * 10 }
    );


    return (
        <ChannelModalLayout isOpen={isOpen} onClose={onClose} title={t("UI.Modals.ChannelInfoModal.title")}>
            {isLoading ? (
                <div className="flex items-center justify-center h-32">
                    <Spinner />
                </div>
            ) : error ? (
                <p className="text-center text-gray-600 dark:text-gray-400">
                    {t("UI.Modals.ChannelInfoModal.error") || "Error loading channel data"}
                </p>
            ) : channelData ? (
                <div className="flex items-center gap-2">
                    <ChannelInfo
                        title={channelData.name}
                        size="large"
                        subscribersCount={channelData.subscribers_count || 0}
                        postcardsCount={channelData.postcards_count || 0}
                    />

                </div>
            ) : (
                <p className="text-center text-gray-600 dark:text-gray-400">
                    {t("UI.Modals.ChannelInfoModal.noData")}
                </p>
            )}
        </ChannelModalLayout>
    );
};

export default ChannelInfoModal;
